import(/* webpackMode: "eager" */ "/app/app/event/error.js");
